<template>
	<div class="c-running flex flex-nowrap items-center gap-12 rounded-md text-center">
		<div class="text-nowrap color-red-c text-sm font-medium">
			<i class="fas fa-lg fa-arrow-circle-up color-red-c va-baseline text-sm"> </i>
			{{ valueBuy }}
		</div>

		<div class="text-nowrap color-green-c text-sm font-medium">
			<i class="fas fa-lg fa-arrow-circle-down color-green-c va-baseline text-sm"> </i>
			{{ valueSell }}
		</div>

		<div class="self-start">
			<Tooltip type_prop="2" iconWidth_prop="0.625rem" iconHeight_prop="0.625rem" textPosition_prop="bottom"
				text_prop="Indicator that shows price movement" />
		</div>

	</div>
</template>

<script>
/*eslint-env jquery*/
import Decimal from 'decimal.js'

import Tooltip from './Tooltip.vue'

export default {
	name: 'RunningPriceV2',
	props: {
		valueSell_prop: {
			type: Number,
			default: 0
		},

		valueBuy_prop: {
			type: Number,
			default: 0
		},
	},

	components: {
		Tooltip,
	},

	data() {
		return {
			contractId: this.$store.state.contractIds.contract_1g, // use contract 1g
		}
	},
	computed: {
		product() {
			const contracts = this.$store.state.contracts
			const products = this.$store.state.products

			if (!contracts || !products) {
				return null
			}

			const contract = this.$store.state.contracts.find(obj => obj.id == this.contractId)
			const product = this.$store.state.products.find(obj => obj.id == contract.attributes.productId)

			return product || null
		},
		gold() {
			const golds = this.$store.state.golds
			if (!golds) {
				return null
			}

			return golds[this.contractId] || null
		},

		valueSell() {
			if (!this.gold || !this.product) {
				return '-'
			}

			if (!this.gold.runningPriceSell) {
				return '-'
			}

			return new Decimal(this.gold.runningPriceSell).toDecimalPlaces(2).toNumber()
		},

		valueBuy() {
			if (!this.gold || !this.product) {
				return '-'
			}

			if (!this.gold.runningPriceBuy) {
				return '-'
			}

			return new Decimal(this.gold.runningPriceBuy).toDecimalPlaces(2).toNumber()
		},
	}
}
</script>

<style scoped>
.c-running {
	background-color: var(--grey-1-color);
	color: white;
	padding: 0.5em 0.75em;
	height: 2.5em;
	font-size: 1rem;
	margin: 0;
}

.c-running-inner {
	padding: 0.55em;
}

.c-running-inner.c-running-sell {
	color: #F44336;
}

.c-running-inner.c-running-buy {
	color: #43A047;
}
</style>